<template>
    <div class="cart-component" style="margin-bottom: 0 !important;">
        <v-btn flat small icon class="nav-icon ma-0" color="white" @click="cart">
            <v-badge overlap color="secondary">
                <span slot="badge" class="" v-if="cartBadge != 0"> {{cartBadge}} </span>
                <v-icon :color="iconColor">mdi-cart-outline</v-icon>
            </v-badge>
        </v-btn>
        <LoginRegisterModal :dialog="loginRegisterModalShow" :open-cart="true" @hide="loginRegisterModalShow = false"></LoginRegisterModal>
    </div>
</template>

<script>
    import LoginRegisterModal from "./LoginRegisterModal";
    export default {
        components: {
            LoginRegisterModal
        },
        props: {
            iconColor: {
                default: 'white',
            }
        },
        data() {
            return {
                loginRegisterModalShow: false,
                cartBadge: 0,
            }
        },
        methods: {
            cart() {
                if (this.$store.state.user != null) {
                    this.$router.push({
                        path: "/cart"
                    });
                } else {
                    this.loginRegisterModalShow = true;
                }
            },
            async getCart(){
                if (this.$store.state.user != null) {
                    await axios.get('/api/shop/count-cart')
                        .then(res => {
                            this.cartBadge = res.data;
                        })
                        .catch(err => {
                            if (err.response.data.message === "Server Error"){
                                this.getCart();
                            }
                            // console.log(err.response.data.message);
                        })
                        .finally(() => {});
                }
            }
        },
        mounted() {
            this.getCart();
        }
    }

</script>
